import { useState } from "react";
import { useReports } from "../context/ReportsContext";
import ReportsSkeleton from "./ReportsSkeleton";
import { CLIENT_ID } from "../../../utils/constants";
import PdfIcon from "../../../images/app_bar/report.svg";
import OpenReportsIcon from "../../../images/icons/exit.svg";
const UnlockedReports = () => {
  const { reports, loading, error, sendFeedback } = useReports();

  const [feedback, setFeedback] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  // console.log("reports", reports);

  const handleSubmitFeedback = async () => {
    if (!feedback.trim()) return;

    try {
      setIsSubmitting(true);
      await sendFeedback(CLIENT_ID, feedback);
      setFeedback("");
    } catch (err) {
      console.error("Feedback submission error:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOpenPdf = async (url, date) => {
    try {
      setIsDownloading(true);
      // Open the PDF in a new tab
      window.open(url, "_blank");
    } catch (err) {
      console.error("PDF open error:", err);
    } finally {
      setIsDownloading(false);
    }
  };

  if (loading && !reports) return <ReportsSkeleton />;
  if (error) return <div className="text-red-500 p-4">{error}</div>;
  if (!reports || reports.reports.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8">
        <div className="w-32 h-32 bg-n100 rounded-full mb-4"></div>
        <h3 className="text-lg font-semibold text-p300 mb-2">
          No Reports available
        </h3>
        <p className="text-sm font-medium text-gray-400 text-center max-w-md">
          Hi there! no market reports are available at the moment. Please check
          back later!
        </p>
      </div>
    );
  }

  const latestReport = reports.reports[0];

  return (
    <div className="flex flex-col space-y-5 ">
      <h3 className="text-base font-semibold text-p300">Latest report</h3>
      <div
        className="flex items-center p-3 border border-n200 rounded cursor-pointer"
        onClick={() => handleOpenPdf(latestReport.url, latestReport.date)}>
        <div className="mr-3">
          <img className="w-9 h-11" src={PdfIcon} alt="" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-p300">{latestReport.date}</p>
          <p className="text-xs font-medium text-n400">
            Updated on: {latestReport.date} 8:00 AM
          </p>
        </div>
        <div className="p-3 border border-n200 rounded">
          {isDownloading ? (
            <div className="w-4 h-4 border-2 border-p300 border-t-transparent rounded-full animate-spin"></div>
          ) : (
            <img src={OpenReportsIcon} alt="" />
          )}
        </div>
      </div>
      <div className="mt-5">
        <textarea
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Have some feedback regarding the reports? Please share it with us."
          className="text-sm w-full p-3 border border-n200 rounded bg-n100 focus:outline-none focus:ring-1 focus:ring-n300 h-40"
        />
      </div>
      <button
        onClick={handleSubmitFeedback}
        disabled={!feedback.trim() || isSubmitting}
        className={`w-full py-3 px-4 text-xs font-semibold rounded ${
          !feedback.trim() ? "bg-n500 text-p300 " : "bg-swipe-button text-p400"
        }`}>
        {isSubmitting ? (
          <div className="flex items-center justify-center">
            <div className="w-4 h-4 border-2 border-n200 border-t-transparent rounded-full animate-spin mr-2"></div>
            Submitting...
          </div>
        ) : (
          "Submit feedback"
        )}
      </button>
    </div>
  );
};

export default UnlockedReports;
